import { render, staticRenderFns } from "./BuildMetrics.vue?vue&type=template&id=8245b392&scoped=true&"
import script from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BuildMetrics.vue?vue&type=style&index=0&id=8245b392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8245b392",
  null
  
)

export default component.exports